import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			gridProps: {
				breakpoints: [
					{
						modifier: 'down',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'definition.list',
													},
													{
														key: 'heading',
														style: {
															padding: {
																top: '9px',
															},
														},
													},
													{
														key: 'dropdown',
														style: {
															overrides: [
																{
																	selector: '[data-selector="base-dropdown-header"]',
																	style: {
																		display: 'block',
																		height: '40px',
																		margin: {
																			bottom: '32px',
																			top: '20px',
																		},
																		width: 'auto',
																	},
																},
															],
														},
													},
												],
												style: {
													width: '100%',
												},
											},
										],
									},
								],
							},
						},
						size: 'small',
					},
					{
						modifier: 'up',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'definition.list',
													},
												],
											},
										],
									},
									{
										columns: [
											{
												components: [
													{
														key: 'heading',
													},
												],
												style: {
													flex: {
														grow: '1',
													},
												},
											},
											{
												components: [
													{
														key: 'dropdown',
													},
												],
												style: {
													flex: {
														grow: '0',
													},
													width: '243px',
												},
											},
										],
										style: {
											padding: {
												top: '9px',
											},
										},
									},
								],
							},
						},
						size: 'medium',
					},
				],
			},
		},
		capabilities: {
			query: {
				code: 'combined_capability',
				entityType: 'CLSS',
				queryOptionsType: 'property',
			},
		},
		definitions: {
			props: {
				itemSeparator: ' | ',
				removeEmptyItems: true,
				termSuffix: ':',
			},
			queries: {
				items: [
					{
						definition: {
							code: 'legal_entity_fund',
							entityType: 'CLSS',
							placeholder: '',
							queryOptionsType: 'property',
						},
					},
					{
						definition: {
							code: 'isin',
							entityType: 'CLSS',
							placeholder: '-',
							queryOptionsType: 'property',
						},
					},
				],
			},
		},
		dropdown: {
			label: 'Select Share Class',
			dataEntitiesId: 'dropdown',
			hideIfEmpty: true,
			placeholder: 'Change Share Class',
			resultItemLabel: {
				queryOptionsType: 'fundLists',
				subQueries: [
					{
						queryId: 'shareClass',
						queryOptionsType: 'none',
						separators: [
							'-',
						],
						subQueries: [
							{
								code: 'share_class_type',
								entityType: 'CLSS',
								queryId: 'shareClassType',
								queryOptionsType: 'property',
							},
							{
								code: 'distribution_policy_abbreviation',
								entityType: 'CLSS',
								queryId: 'distributionPolicyAbbreviation',
								queryOptionsType: 'property',
							},
						],
						value: '{sub:shareClassType}-{sub:distributionPolicyAbbreviation}',
					},
				],
				value: 'Class {sub:shareClass}',
			},
			singleItemDisplayOnly: false,
		},
		heading: {
			props: {},
			queries: {
				title: {
					queryOptionsType: 'none',
					separators: [
						' | ',
					],
					subQueries: [
						{
							code: 'sub_fund',
							entityType: 'CLSS',
							queryId: 'subFund',
							queryOptionsType: 'property',
						},
						{
							queryId: 'shareClass',
							queryOptionsType: 'none',
							separators: [
								'-',
							],
							subQueries: [
								{
									code: 'share_class_type',
									entityType: 'CLSS',
									queryId: 'shareClassType',
									queryOptionsType: 'property',
								},
								{
									code: 'distribution_policy_abbreviation',
									entityType: 'CLSS',
									queryId: 'distributionPolicyAbbreviation',
									queryOptionsType: 'property',
								},
							],
							value: '{sub:shareClassType}-{sub:distributionPolicyAbbreviation}',
						},
					],
					value: '{sub:subFund} | {sub:shareClass}',
				},
			},
		},
	},
	redirect: {
		inputs: [
			{
				key: 'siteLocale',
				query: {
					key: 'siteLocale',
					queryOptionsType: 'input',
				},
			},
			{
				key: 'audience',
				query: {
					key: 'audience',
					queryOptionsType: 'input',
					transforms: [
						{
							caseType: 'param',
							transformOptionsType: 'case',
						},
					],
				},
			},
			{
				key: 'fullShareClassName',
				query: {
					code: 'full_share_class_name',
					entityType: 'CLSS',
					queryOptionsType: 'property',
					transforms: [
						{
							aliases: [
								{
									replacement: '',
									source: '&',
								},
							],
							transformOptionsType: 'alias',
						},
						{
							caseType: 'param',
							transformOptionsType: 'case',
						},
					],
				},
			},
		],
		redirect: {
			defaultUrl: '/{siteLocale}/{audience}/{fullShareClassName}',
			options: {
				preserveOriginPath: false,
			},
		},
	},
};
